import { Controller } from "@hotwired/stimulus"

// 検索フォーム等で、内側の input/select の変更（blur 含む）で自動的に submit する。
// `data-controller="auto-submit"` を `<form>` 要素に付けて使う。
//
// `change` イベントは: select 変更時、テキスト入力欄の blur 時、radio/checkbox トグル時に発火する。
// したがって「変更があって確定したら」submit する挙動になる。
//
// あわせて Turbo back の cache 復元時に、フォーム値が URL のクエリと食い違う状態
// （ユーザが直前に別の値をクリックしたあと submit を経てから戻ってきたケース）を
// 防ぐため、connect 時に URL パラメータを正として radio/checkbox/text/select を上書きする。
export default class extends Controller {
  connect() {
    this.handler = this.submit.bind(this)
    this.element.addEventListener("change", this.handler)
    this.syncFromURL()
  }

  disconnect() {
    this.element.removeEventListener("change", this.handler)
  }

  submit() {
    this.element.requestSubmit()
  }

  // フォーム内の名前付き入力を URL クエリに合わせ直す。choicesjs 等
  // 自前で URL 同期する controller の対象は触らない（data-no-url-sync）。
  syncFromURL() {
    const params = new URL(window.location.href).searchParams
    // URL に param が一切無い場合は、サーバ側で渡されたデフォルト選択
    // (例: 出金依頼一覧の status=pending) を尊重する。
    if ([...params].length === 0) return

    const inputs = this.element.querySelectorAll("input[name], select[name], textarea[name]")
    inputs.forEach((el) => {
      if (el.closest("[data-no-url-sync]")) return
      if (el.dataset.choicesjsTarget === "select") return

      const name = el.name
      const urlValue = params.get(name)

      if (el.type === "radio") {
        el.checked = (urlValue ?? "") === el.value
      } else if (el.type === "checkbox") {
        if (urlValue === null) {
          el.checked = false
        } else {
          el.checked = urlValue === el.value
        }
      } else if (el.tagName === "SELECT" || el.type === "text" || el.type === "search" || el.type === "hidden" || el.tagName === "TEXTAREA") {
        el.value = urlValue ?? ""
        // 書き戻した生値を整形 controller (comma-number 等) に追随させる。
        // connect 順に依存せず、未接続なら向こうの connect 側で整形される。
        el.dispatchEvent(new Event("input", { bubbles: true }))
      }
    })
  }
}
